import React, { useEffect, useRef, useState } from 'react';
import ArcadeDemo from './ArcadeDemo';
import cabinetArtwork from '../assets/arcade-cabinet.png';
import coinArtwork from '../assets/dopi-coin.png';

const COIN_ANIMATION_MS = 1500;
const ArcadeCabinet = ({ onStart }) => {
  const [starting, setStarting] = useState(false);
  const [signIn, setSignIn] = useState(false);
  const startingRef = useRef(false);
  const timerRef = useRef(null);

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const handleStart = () => {
    if (startingRef.current) return;
    startingRef.current = true;
    setStarting(true);
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const destination = signIn ? '/sign-in' : '/sign-up';
    timerRef.current = window.setTimeout(() => onStart(destination), reducedMotion ? 100 : COIN_ANIMATION_MS);
  };

  return (
    <section className={`arcade-cabinet${starting ? ' arcade-cabinet--starting' : ''}`} aria-label="Dopatize arcade machine">
      <img className="arcade-cabinet__art" src={cabinetArtwork} alt="" width="1122" height="1402" />
      <header className="arcade-marquee"><h1>Dopatize</h1></header>
      <div className="arcade-screen">
        <ArcadeDemo starting={starting} signIn={signIn} />
      </div>
      <div className="arcade-joystick-control">
        <button
          type="button"
          className="arcade-joystick"
          aria-label="Sign-in mode"
          aria-pressed={signIn}
          disabled={starting}
          onClick={() => { if (!startingRef.current) setSignIn((value) => !value); }}
        >
          <span className="arcade-joystick__base" aria-hidden="true" />
          <span className="arcade-joystick__lever" aria-hidden="true">
            <span className="arcade-joystick__shaft" />
            <span className="arcade-joystick__ball" />
          </span>
        </button>
        <span className="arcade-joystick-control__label" aria-hidden="true">
          <span className={!signIn ? 'is-selected' : ''}>SIGN UP</span>
          <span className={signIn ? 'is-selected' : ''}>SIGN IN</span>
        </span>
      </div>
      <div className="arcade-start-control">
        <span className="arcade-start-control__label" id="arcade-start-label">START</span>
        <button type="button" className="arcade-start-button" aria-labelledby="arcade-start-label" aria-describedby={`arcade-start-prompt${signIn ? '' : ' arcade-trial-note'}`} disabled={starting} onClick={handleStart} />
      </div>
      <div className="arcade-coin-rest" aria-hidden="true">
        <div className="arcade-coin-target">
          <span className="arcade-coin">
            {Array.from({ length: 24 }, (_, index) => (
              <span key={index} className="arcade-coin__edge" style={{ '--coin-edge-angle': `${index * 15}deg` }} />
            ))}
            <img className="arcade-coin__face arcade-coin__face--front" src={coinArtwork} alt="" width="1254" height="1254" />
            <img className="arcade-coin__face arcade-coin__face--back" src={coinArtwork} alt="" width="1254" height="1254" />
          </span>
        </div>
      </div>
      <span className="arcade-status" role="status">{starting ? `Inserting coin. Opening ${signIn ? 'sign in' : 'your free trial signup'}…` : `${signIn ? 'Sign in' : 'Sign up'} selected.`}</span>
    </section>
  );
};

export default ArcadeCabinet;
